export class Column {
  id: string;
  name: string;
  type: string;
  visible: boolean;
  displayOrder: number;
  filter: boolean;
  info: boolean;
  sortable: boolean;
  sortId: number;
  width?: number;
  fixed?: boolean; // true means can not be hidden
}

export const SKUTableHeader: Column[] = [
  {
    sortId: null,
    id: "image",
    name: "Image",
    type: "image",
    visible: true,
    displayOrder: 1,
    filter: false,
    info: false,
    sortable: false,
    width: 60,
  },
  {
    sortId: 1,
    id: "skuId",
    name: "ID",
    type: "string",
    visible: true,
    displayOrder: 2,
    filter: true,
    info: true,
    sortable: true,
    width: 175,
    fixed: true,
  },
  {
    sortId: 2,
    id: "title",
    name: "Title",
    type: "string",
    visible: true,
    displayOrder: 3,
    filter: true,
    info: false,
    sortable: true,
    width: 140,
  },
  {
    sortId: 4,
    id: "fnSku",
    name: "FNSKU",
    type: "string",
    visible: false,
    displayOrder: 5,
    filter: true,
    info: false,
    sortable: true,
    width: 250,
  },
  {
    sortId: 6,
    id: "total",
    name: "FBA Stock",
    type: "string",
    visible: true,
    displayOrder: 8,
    filter: true,
    info: false,
    sortable: true,
    width: 110,
  },
  {
    sortId: 16,
    id: "buyBox",
    name: "Buy Box",
    type: "string",
    visible: true,
    displayOrder: 11,
    filter: true,
    info: false,
    sortable: true,
    width: 150,
  },
  {
    sortId: 14,
    id: "category",
    name: "Rank",
    type: "string",
    visible: true,
    displayOrder: 13,
    filter: true,
    info: false,
    sortable: true,
    width: 120,
  },
  {
    sortId: 17,
    id: "isOverSized",
    name: "FBA Type",
    type: "string",
    visible: true,
    displayOrder: 15,
    filter: true,
    info: false,
    sortable: true,
    width: 115,
  },
  {
    sortId: 12,
    id: "isShiperr",
    name: "FBA Error",
    type: "boolean",
    visible: true,
    displayOrder: 16,
    filter: true,
    info: false,
    sortable: true,
    width: 250,
  },
  {
    sortId: 9,
    id: "note",
    name: "Notes",
    type: "note",
    visible: true,
    displayOrder: 17,
    filter: true,
    info: false,
    sortable: true,
    width: 250,
  },
  {
    sortId: null,
    id: "lQty",
    name: "In Preparation",
    type: "string",
    visible: true,
    displayOrder: 9,
    filter: false,
    info: false,
    sortable: false,
    width: 95,
  },
  {
    sortId: null,
    id: "shippingInput",
    name: "Select Quantity",
    type: "shippingInput",
    visible: true,
    displayOrder: 18,
    filter: false,
    info: false,
    sortable: false,
    width: 150,
  },
];

export const VendorTableHeader: Column[] = [
  {
    sortId: 2,
    id: "id",
    name: "ID",
    type: "string",
    visible: true,
    displayOrder: 1,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 3,
    id: "name",
    name: "Name",
    type: "string",
    visible: true,
    displayOrder: 2,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 4,
    id: "address",
    name: "Address",
    type: "string",
    visible: true,
    displayOrder: 3,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 5,
    id: "phone",
    name: "Phone1",
    type: "string",
    visible: true,
    displayOrder: 4,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 6,
    id: "phone2",
    name: "Phone2",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 7,
    id: "email",
    name: "Email",
    type: "string",
    visible: true,
    displayOrder: 6,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 8,
    id: "shipAvg",
    name: "Avg. Shipping",
    type: "string",
    visible: true,
    displayOrder: 7,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 9,
    id: "on1",
    name: "2D Velocity",
    type: "string",
    visible: true,
    displayOrder: 8,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 10,
    id: "on2",
    name: "7D Velocit",
    type: "string",
    visible: true,
    displayOrder: 9,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 11,
    id: "on3",
    name: "14D Velocity",
    type: "string",
    visible: true,
    displayOrder: 10,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 12,
    id: "on4",
    name: "30D Velocity",
    type: "string",
    visible: true,
    displayOrder: 11,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 13,
    id: "leadDays",
    name: "Lead Time",
    type: "string",
    visible: true,
    displayOrder: 12,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 14,
    id: "purchaseDays",
    name: "Stock Days",
    type: "string",
    visible: true,
    displayOrder: 13,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 15,
    id: "purchaseAmnt",
    name: "PO's Suggested",
    type: "string",
    visible: true,
    displayOrder: 14,
    filter: true,
    info: true,
    sortable: true,
  },
  {
    sortId: 16,
    id: "url",
    name: "Url",
    type: "string",
    visible: true,
    displayOrder: 15,
    filter: true,
    info: true,
    sortable: false,
  },
];

export const ItemTableHeader: Column[] = [
  {
    sortId: 2,
    id: "id",
    name: "ID",
    type: "string",
    visible: true,
    displayOrder: 1,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 3,
    id: "name",
    name: "Name",
    type: "string",
    visible: true,
    displayOrder: 2,
    filter: true,
    info: true,
    sortable: true,
    width: 100,
  },
  {
    sortId: 22,
    id: "inbound",
    name: "Inbound",
    type: "string",
    visible: true,
    displayOrder: 3,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 4,
    id: "qty",
    name: "In Stock",
    type: "string",
    visible: true,
    displayOrder: 4,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 24,
    id: "onShelf",
    name: "On Shelf",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 115,
  },
  {
    sortId: 25,
    id: "missing",
    name: "Missing",
    type: "string",
    visible: true,
    displayOrder: 6,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 23,
    id: "lQty",
    name: "Vendors QTY",
    type: "string",
    visible: true,
    displayOrder: 7,
    filter: true,
    info: true,
    sortable: true,
    width: 145,
  },
  {
    sortId: null,
    id: "url",
    name: "Url",
    type: "string",
    visible: true,
    displayOrder: 8,
    filter: true,
    info: true,
    sortable: false,
    width: 90,
  },
  {
    sortId: 5,
    id: "vendor",
    name: "Vendor",
    type: "string",
    visible: true,
    displayOrder: 9,
    filter: true,
    info: true,
    sortable: true,
    width: 105,
  },
  {
    sortId: 6,
    id: "price",
    name: "Price",
    type: "string",
    visible: true,
    displayOrder: 10,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
  {
    sortId: 7,
    id: "avgPrice",
    name: "AVG Price",
    type: "string",
    visible: true,
    displayOrder: 11,
    filter: true,
    info: true,
    sortable: true,
    width: 105,
  },
  {
    sortId: 8,
    id: "note",
    name: "Note",
    type: "string",
    visible: true,
    displayOrder: 12,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
  {
    sortId: 15,
    id: "caseQ",
    name: "Case QT",
    type: "string",
    visible: true,
    displayOrder: 13,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
  {
    sortId: 16,
    id: "enforce",
    name: "Enoforce Case",
    type: "string",
    visible: true,
    displayOrder: 14,
    filter: true,
    info: true,
    sortable: true,
    width: 120,
  },
  {
    sortId: 17,
    id: "length",
    name: "Length",
    type: "string",
    visible: true,
    displayOrder: 15,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
  {
    sortId: 18,
    id: "height",
    name: "Height",
    type: "string",
    visible: true,
    displayOrder: 16,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
  {
    sortId: 19,
    id: "width",
    name: "Width",
    type: "string",
    visible: true,
    displayOrder: 17,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
  {
    sortId: 20,
    id: "weight",
    name: "Weight",
    type: "string",
    visible: true,
    displayOrder: 18,
    filter: true,
    info: true,
    sortable: true,
    width: 100,
  },
  {
    sortId: 21,
    id: "vendId",
    name: "Vendor Item Id",
    type: "string",
    visible: true,
    displayOrder: 19,
    filter: true,
    info: true,
    sortable: true,
    width: 140,
  },
  {
    sortId: 26,
    id: "codes",
    name: "Codes",
    type: "string",
    visible: true,
    displayOrder: 20,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
  {
    sortId: 27,
    id: "brand",
    name: "Brand",
    type: "string",
    visible: true,
    displayOrder: 21,
    filter: true,
    info: true,
    sortable: true,
    width: 90,
  },
];

export const PricingFbaTableHeader: Column[] = [
  {
    sortId: 1,
    id: "image",
    name: "Image",
    type: "image",
    visible: true,
    displayOrder: 1,
    filter: true,
    info: true,
    sortable: true,
    width: 60,
  },
  {
    sortId: 2,
    id: "id",
    name: "ID",
    type: "string",
    visible: true,
    displayOrder: 2,
    filter: true,
    info: true,
    sortable: true,
    width: 200,
  },
  {
    sortId: 3,
    id: "buyBox",
    name: "Buy Box",
    type: "string",
    visible: true,
    displayOrder: 3,
    filter: true,
    info: true,
    sortable: true,
    width: 100,
  },
  {
    sortId: 4,
    id: "offer",
    name: "Offer",
    type: "string",
    visible: false,
    displayOrder: 4,
    filter: true,
    info: true,
    sortable: true,
    width: 100,
  },
  {
    sortId: 5,
    id: "costMinMax",
    name: "Cost",
    type: "string",
    visible: true,
    displayOrder: 6,
    filter: true,
    info: true,
    sortable: true,
    width: 100,
  },
  {
    sortId: 6,
    id: "minPrice",
    name: "Min Price",
    type: "string",
    visible: true,
    displayOrder: 6,
    filter: true,
    info: true,
    sortable: true,
    width: 100,
  },
  {
    sortId: 7,
    id: "maxPrice",
    name: "Max Price",
    type: "string",
    visible: true,
    displayOrder: 6,
    filter: true,
    info: true,
    sortable: true,
    width: 100,
  },
  {
    sortId: 8,
    id: "bBUpdatedRepricedFreezedUntil",
    name: "BB Updated Repriced Freezed Until",
    type: "string",
    visible: true,
    displayOrder: 7,
    filter: true,
    info: true,
    sortable: true,
    width: 220,
  },
  {
    sortId: 9,
    id: "minManualset",
    name: "Min Manual set",
    type: "string",
    visible: true,
    displayOrder: 8,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 10,
    id: "maxManualset",
    name: "Max Manual set",
    type: "string",
    visible: true,
    displayOrder: 9,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 11,
    id: "mapPrice",
    name: "Map Price",
    type: "string",
    visible: false,
    displayOrder: 10,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 12,
    id: "model",
    name: "Model",
    type: "string",
    visible: true,
    displayOrder: 12,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 13,
    id: "onOff",
    name: "On/Off",
    type: "string",
    visible: true,
    displayOrder: 13,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 14,
    id: "fbaStock",
    name: "Fba Stock",
    type: "string",
    visible: false,
    displayOrder: 13,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 15,
    id: "rank",
    name: "Rank",
    type: "string",
    visible: true,
    displayOrder: 13,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
  {
    sortId: 16,
    id: "note",
    name: "Note",
    type: "string",
    visible: true,
    displayOrder: 13,
    filter: true,
    info: true,
    sortable: true,
    width: 110,
  },
];

export const PricingSellerTableHeader: Column[] = [
  {
    sortId: 1,
    id: "id",
    name: "ID",
    type: "string",
    visible: true,
    displayOrder: 1,
    filter: true,
    info: true,
    sortable: true,
    width: 60,
  },
  {
    sortId: 2,
    id: "name",
    name: "Name",
    type: "string",
    visible: true,
    displayOrder: 2,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 3,
    id: "competingListings",
    name: "Competing Listings",
    type: "string",
    visible: true,
    displayOrder: 3,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 4,
    id: "winningBB",
    name: "Winning BB",
    type: "string",
    visible: true,
    displayOrder: 4,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 5,
    id: "ignored",
    name: "Ignored",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 6,
    id: "ignoreEvenWithBB",
    name: "Ignore Even with BB",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
];

export const PricingHistoryTableHeader: Column[] = [
  {
    sortId: 1,
    id: "date",
    name: "Date",
    type: "string",
    visible: true,
    displayOrder: 1,
    filter: true,
    info: true,
    sortable: true,
    width: 60,
  },
  {
    sortId: 2,
    id: "sku",
    name: "SKU",
    type: "string",
    visible: true,
    displayOrder: 2,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 3,
    id: "asin",
    name: "Asin",
    type: "string",
    visible: true,
    displayOrder: 3,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 4,
    id: "newPrice",
    name: "New Price",
    type: "string",
    visible: true,
    displayOrder: 4,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 5,
    id: "oldPrice",
    name: "Old Price",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 6,
    id: "priceDifference",
    name: "Price Difference",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 7,
    id: "actionType",
    name: "Action Type",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 8,
    id: "priceModel",
    name: "Price Model",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
  {
    sortId: 9,
    id: "overstockLevel",
    name: "Overstock Level",
    type: "string",
    visible: true,
    displayOrder: 5,
    filter: true,
    info: true,
    sortable: true,
    width: 150,
  },
];

export const FBAType = {
  0: "Standard",
  1: "Oversized",
  2: "Hazmat",
  3: "Small & Light",
};

export enum FBATypeEnum {
  Standard = 'Standard',
  Oversized = 'Oversized',
  Hazmat = 'Hazmat',
  SmallAndLight = 'Small & Light',
}

export enum POStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
  InTransit = 'In transit',
  Received = 'Received',
}


export enum AccountRegion {
  Amazon = 1,
  AmazonUk = 2,
  AmazonAU = 3
}

export enum RedirectUrls {
  AppUrl = 'https://app.nineyard.com',
  PlanyardUrl = 'https://app2.nineyard.com' 
}